import { FC } from 'react';
import { useIntl } from 'react-intl';

import { PageTitle } from '../../../_metronic/layout/core';
import { CrossSellingReport } from '../../modules/cross-selling';

export const CrossSellingReportPage: FC = () => {
  const intl = useIntl();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'crossSellingReport.title' })}
      </PageTitle>
      <div className="row gy-5 g-xl-8">
        <div className="card p-10">
          <CrossSellingReport />
        </div>
      </div>
    </>
  );
};
